// extracted by mini-css-extract-plugin
export default {"toaster":"fcX3O5d2rML69aIGxdzY"};